import { useEffect, useRef } from "react";

interface IFadeUpProps {
  children: React.ReactNode;
}

const FadeUp: React.FC<IFadeUpProps> = ({ children }) => {
  const fadeUpRef = useRef(null);

  useEffect(() => {
    const element = fadeUpRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.remove("opacity-0");
            entry.target.classList.add("animate-fade-up");
          } else {
            entry.target.classList.remove("animate-fade-up");
            entry.target.classList.add("opacity-0");
          }
        });
      },
      { threshold: 0.1 },
    );

    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  return (
    <span ref={fadeUpRef} className="h-full w-full ">
      {children}
    </span>
  );
};

export default FadeUp;
